module.exports = __webpack_public_path__ + "static/media/month_11.6b0590a5.png";